import { Paper, Stack } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import { PaymentForm } from '../../../components/payment/PaymentForm';
import { SendForApprovalPanel } from '../../../components/booking/SendForApprovalPanel';
import type { TransferFlowState } from '../flowConfig';

/** Thin wrapper around the shared `PaymentForm` — the flow's payment step reads the
 *  transfer booking's amount/currency out of the accumulated cart and forwards the
 *  card/cari result into `runStep`. 3D Secure redirect is handled inside the flow's
 *  `runPayment` (see flowConfig.ts). */
export function TransferPaymentStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const booking = flow.state.cart?.transferBookings?.[0];

  return (
    <Paper sx={{ p: 3 }}>
      <Stack spacing={2}>
        <SendForApprovalPanel product="Transfer" cart={flow.state.cart} />
        <PaymentForm
          amount={booking?.totalFare ?? flow.state.cart?.remainingTotal}
          currency={booking?.currency ?? 'TRY'}
          loading={flow.status === 'running'}
          shoppingCartId={flow.state.shoppingCartId}
          onSubmit={({ paymentForm }) => {
            flow.runStep({ paymentForm }).catch(() => undefined);
          }}
        />
      </Stack>
    </Paper>
  );
}
